// Curation on top of wordDatabase.json for NameIt Run, where a single wrong
// "wrong answer" is far more visible than in a reviewed round: a decoy the
// player can reasonably argue belongs to the round's category makes the game
// feel unfair. Regenerate the candidate list with `node scripts/run-word-audit.mjs`.

// Never shown: not really nouns of their category, or too obscure to judge at speed.
export const EXCLUDED = new Set([
  'decant', 'quaint', 'qualm', 'quaff', 'quake', 'quango', 'jangle', 'jag', 'union', 'unit',
  'zone', 'octave', 'quaver', 'nasal', 'yaw', 'yagi', 'yahrzeit', 'yashmak', 'zampogna',
  'tabor', 'tamp', 'salver', 'edger', 'gambrel', 'xylem', 'falconry', 'embroidery',
  'king', 'queen', 'zombie', 'mascot', 'icon', 'ancon', 'elver',
  'natterjack', 'quail-plover', 'unau', 'xenops', 'ichneumon', 'quahog', 'mash', 'range',
  'dassie', 'dhole', 'kagu', 'vanga', 'yellowthroat', 'quillback', 'jackfish',
]);

// Words a player could fairly claim for another category, even though the
// database files them elsewhere. They are never used as a decoy for these.
export const ALSO_COUNTS_AS = {
  // animals that are also things
  mouse: ['things'], bat: ['things'], crane: ['things'], seal: ['things'], kite: ['things', 'animals'],
  jack: ['things', 'animals'], ram: ['things'], mule: ['things'], fly: ['things'], mole: ['things'],
  // animals that are also names
  robin: ['names'], jay: ['names'], wren: ['names'], teal: ['names'], raven: ['names'],
  ray: ['names', 'things'], finch: ['names'], drake: ['names'], fawn: ['names'], bunny: ['names'],
  // things that are also animals or names
  octopus: ['animals', 'food', 'things'], quail: ['animals', 'things'], jasper: ['names', 'things'], olive: ['names', 'things'], quill: ['names'],
  narcissus: ['names'], ruby: ['names'], amber: ['names'], penny: ['names'],
  // things that are also places
  island: ['places'], garden: ['places'], kitchen: ['places'], ranch: ['places'], zoo: ['places'],
  yard: ['places'], quarry: ['places'], house: ['places'], igloo: ['places'], kennel: ['places'],
  icehouse: ['places'], vault: ['places'], quay: ['places'], moon: ['places'],
  // places that are also things, animals or names
  china: ['things'], bath: ['things'], cologne: ['things'], jersey: ['things', 'places'], panama: ['things'],
  turkey: ['animals', 'things', 'food', 'places'], mars: ['things'], nice: ['things'], guinea: ['animals'],
  georgia: ['names'], florence: ['names', 'places'], sydney: ['names'], jordan: ['names', 'places'], chelsea: ['names'],
  austin: ['names'], adelaide: ['names'], nancy: ['names', 'places'], orlando: ['names'], santiago: ['names'],
  savannah: ['names'], eugene: ['names'], quincy: ['names', 'places'], vernon: ['names', 'places'], virginia: ['names', 'places'],
  aspen: ['names'], dallas: ['names'], denver: ['names'], phoenix: ['names', 'animals'],
  kingston: ['names'], chester: ['names'], lima: ['things'], dover: ['names'], elgin: ['names'],
  // names that are also places or things
  victoria: ['places'], troy: ['places'], paris: ['places'], lincoln: ['places'], regina: ['places'],
  aurora: ['places'], rose: ['things'], holly: ['things'], ivy: ['things'], iris: ['things', 'animals'],
  hazel: ['things'], sage: ['things'], violet: ['things'], daisy: ['things'], lily: ['things'],
  opal: ['things'], jewel: ['names'], coco: ['things'], hunter: ['things', 'names'], mark: ['things'],
  bill: ['things'], pat: ['things'], bob: ['things'], sue: ['things'], will: ['things'],
  faith: ['things'], joy: ['things'], grace: ['things'], hope: ['things'], patience: ['things'],
  dawn: ['things'], summer: ['things'], april: ['things'], may: ['things'], june: ['things'],
  urban: ['things'], chris: ['things'],
  // names that are also everyday words
  blessing: ['things'], gift: ['things'], favour: ['things'], mercy: ['things'], peace: ['things'],
  precious: ['things'], promise: ['things'], prosper: ['things'], purity: ['things'], bright: ['things'],
  sunday: ['things'], jade: ['things'], carol: ['things'], madison: ['places'], india: ['places'],
  israel: ['places'], ginger: ['food', 'names'], candy: ['food', 'names'], honey: ['food', 'names'],
  // animals people also eat
  chicken: ['food'], lamb: ['food'], crab: ['food'], prawn: ['food'], shrimp: ['food'], salmon: ['food'],
  trout: ['food'], cod: ['food'], squid: ['food'], mussel: ['food'], duck: ['food'], goat: ['food'],
  fish: ['food'], sardine: ['animals'], mackerel: ['animals'], kiwi: ['food', 'animals'],
  // audit: legacy database also accepts these as things
  apple: ['things'], egg: ['things'], grape: ['things'], hamburger: ['things'], jam: ['things'],
  jelly: ['things'], kebab: ['things'], lemon: ['things'], mushroom: ['things'], magician: ['things'],
  oatmeal: ['things'], onion: ['things'], orange: ['things'], pizza: ['things'], rabbit: ['things'],
  raccoon: ['things'], radish: ['things'], sandwich: ['things'], taco: ['things'], tangerine: ['things'],
  tailor: ['things'], umpire: ['things'], vinegar: ['things'], walnut: ['things'], yam: ['things'],
  yogurt: ['things'], zucchini: ['things'],
};
